import { Photo, Series } from '@types';
import { StartEndDates } from './getters';

export const sortSeriesByName = (a: Series, b: Series) =>
  a.name.localeCompare(b.name);

export const sortSeriesByNbPhotos =
  (photosBySeries: Record<string, Photo[]>) => (a: Series, b: Series) => {
    const locationPhotosA = photosBySeries[a.id];
    const locationPhotosB = photosBySeries[b.id];
    if (locationPhotosB.length !== locationPhotosA.length) {
      return locationPhotosB.length - locationPhotosA.length;
    }

    return sortSeriesByName(a, b);
  };

export const sortSeriesByDates =
  (
    datesBySeries: Record<string, StartEndDates>,
    photosBySeries: Record<string, Photo[]>
  ) =>
  (a: Series, b: Series) => {
    const datesA = datesBySeries[a.id];
    const datesB = datesBySeries[b.id];
    if (datesA.end !== datesB.end) {
      return datesB.end > datesA.end ? 1 : -1;
    }

    return sortSeriesByNbPhotos(photosBySeries)(a, b);
  };
